import { render, staticRenderFns } from "./BrandAssetsStepCardView.vue?vue&type=template&id=608f8438&scoped=true&"
import script from "./BrandAssetsStepCardView.vue?vue&type=script&lang=js&"
export * from "./BrandAssetsStepCardView.vue?vue&type=script&lang=js&"
import style0 from "./BrandAssetsStepCardView.vue?vue&type=style&index=0&id=608f8438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f8438",
  null
  
)

export default component.exports